const dist = (x1, y1, x2, y2) => {
    return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
};

export const getPath = (x1,y1,x2,y2) => {
    let d = Math.sqrt(dist(x1,y1,x2,y2)) * window.dist;
    let yDistance = Math.abs(y2-y1);
    let xd = Math.abs(x2 - x1);
    let yd = Math.abs(y2 - y1);
    let xDistance = Math.sqrt(xd);
    if (y2 - y1 < 0) {
        yDistance *= -1;
    }
    yDistance += (20 - yd);

    return [x1, y1, x1 + window.x*xDistance, y1+d, x2 - window.x*xDistance, y2-d, x2, y2];
};
